import { useTheme } from "@mui/material/styles";
import { DragLayerMonitorProps } from "@minoru/react-dnd-treeview";
import React from "react";
import { FileProperties } from "../../models/FileProperties";
import { TypeIcon } from "../DelayConfiguration/TypeIcon";
import { customDragPreviewStyles } from "../../styles/dragPreviewStyles";

type Props = {
  monitorProps: DragLayerMonitorProps<FileProperties>;
};

export const CustomDragPreview: React.FC<Props> = (props) => {
  const theme = useTheme();
  const styles = customDragPreviewStyles(theme);

  const item = props.monitorProps.item;

  return (
    <div style={styles.root as React.CSSProperties}>
      <div style={styles.icon as React.CSSProperties}>
        <TypeIcon droppable={item.droppable!} fileType={item?.data?.fileType} />
      </div>
      <div style={styles.label as React.CSSProperties}>{item.text}</div>
    </div>
  );
};
